import { Essentials, Additional } from './Icon.vocab';

export interface IconProps {
  /** The name of the icon */
  icon: string;
  /** The name of the icon for dark mode */
  icon_dark?: string;
  /** Additional class */
  className?: string;
  /** onClick handler */
  onClick?: () => void;
}

/** An icon */
export const Icon = ({ icon, icon_dark, className = '' }: IconProps) => {
  const classNames = ['icn', 'icn--' + icon, className];
  let char = '';
  if (icon in Essentials) {
    char = Essentials[icon];
  } else if (icon in Additional) {
    classNames.push('icn--additional');
    char = Additional[icon];
  } else {
    console.debug(`Icon: The icon ${icon} does not exist.`);
    return null;
  }
  let char_dark: string = '';
  if (icon_dark) {
    if (icon_dark in Essentials) {
      char_dark = Essentials[icon_dark];
    } else if (icon_dark in Additional) {
      classNames.push('icn--additional-dark');
      char_dark = Additional[icon_dark];
    } else {
      console.debug(`Icon: The icon ${icon_dark} does not exist.`);
      return null;
    }
  }

  return (
    <i
      className={classNames.join(' ')}
      data-icon={char}
      {...(char_dark ? { 'data-icon-dark': char_dark } : {})}
    />
  );
};
